import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { getJourneysGroupedByMasterCourse } from '../selectors/studentprofile'
import { fetchCourseOverview } from '../containers/Student/API.js'
import useApiData from './useApiData'

export default courseSectionId => {
  let masterCourse = useSelector(state => {
    // initially assume user is enrolled in course
    const userCourses = [
      ...state.usercourses.currentUserCourses,
      ...state.usercourses.pastUserCourses
    ]
    let mc = userCourses
      .find(c => c.course_section_id === courseSectionId)
      ?.master_course

    // mentor is not enrolled
    // might be viewing student profile, check student enrollments
    if (!mc) {
      const studentCourses = getJourneysGroupedByMasterCourse({
        state,
        excludeNonAcademicYearCourses: true
      })
      mc = studentCourses.find(c => c.enrollments
          .some(e => e.course_section.id === courseSectionId)
        )?.masterCourse
    }

    return mc
  })

  // if the mentor isn't enrolled and not viewing student profile, then the
  // data is not in state, so we need to fetch it from the backend
  const apiData = useApiData()
  const { data: courseOverview } = useQuery(
    // UCQ_ID is added to match query in useFetchData for UCQ
    ['course-overview', { courseSectionId, userCompiledQuestId: null }],
    () => fetchCourseOverview(apiData, courseSectionId),
    {
      refetchOnWindowFocus: false,
      // query is only enabled if we didn't find it from previous two approaches
      enabled: !masterCourse
    }
  )
  
  if (!masterCourse) masterCourse = courseOverview?.master_course

  return masterCourse?.operational_type === 'mentor_custom' ?? false
}
